import { render } from "./ProjectsTable.vue?vue&type=template&id=34025769&ts=true"
import script from "./ProjectsTable.vue?vue&type=script&lang=ts"
export * from "./ProjectsTable.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\DigitalTrading\\Projects\\Autom8.AI\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__